export default function React_Conditionals() {
  return (
    <div>
      <h1>React_Conditionals Component</h1>
      <p>This is the React_Conditionals tutorial page.</p>
    </div>
  );
}
